import { jsx } from '@emotion/react/jsx-runtime';
import { createPolymorphicComponent, useSlot } from '@nettbureau/core';
import { Shape } from './shape.js';

/**
 * A rectangle component creates a rectangular shape.
 */ const Rectangle = createPolymorphicComponent((props, ref)=>{
    const [mergedProps, mergedRef] = useSlot('Rectangle', props, ref);
    const { children, ...shapeProps } = mergedProps;
    return /*#__PURE__*/ jsx(Shape, {
        ...shapeProps,
        ref: mergedRef,
        figure: "rectangle",
        children: children
    });
});

export { Rectangle };
//# sourceMappingURL=rectangle.js.map
